import { createSlice } from '@reduxjs/toolkit'
import { InstancesSchema } from '../types/Instance'
import { fetchInstances } from '../srevices/fetchInstances'
import {
	getFunctionalityCurrentValueMinMax
} from '../lib/getFunctionalityCurrentValueMinMax'
import { fetchInstancesAll } from '../srevices/fetchInstancesAll'


const initialState: InstancesSchema = {
	limit: 10,
	error: '',
	isLoading: false,
	paginatedInstances: {
		currentPage: 1,
		items: []
	},
	funcCurrentValuesMinMax: {},
	filter: {},
	queryFilter: {},
	sort: {},
	allInstances: {
		isLoading: false,
		error: '',
		items: []
	}
}

const instancesSlice = createSlice({
	name: 'instances',
	initialState,
	reducers: {
		setPage: (state, action) => {
			state.paginatedInstances.currentPage = action.payload
		},
		resetPage: (state) => {
			state.paginatedInstances.currentPage = 1
		},
		setLimit: (state, action) => {
			state.limit = action.payload
		},
		setSort: (state, action) => {
			state.sort.sort = action.payload
		},
		setDirection: (state, action) => {
			state.sort.direction = action.payload
		},
		setInstanceName: (state, action) => {
			state.filter.instanceName = action.payload
		},
		setLabel: (state, action) => {
			state.filter.label = action.payload
		},
		setIp: (state, action) => {
			state.filter.ip = action.payload
		},
		setProductVersion: (state, action) => {
			state.filter.productVersion = action.payload
		},
		setQueryFilter: (state) => {
			state.queryFilter = { ...state.filter }
		},
		removeFilter: (state, action) => {
			const filterName: keyof typeof state.queryFilter = action.payload
			delete state.filter[filterName]
			delete state.queryFilter[filterName]
		},
		resetFilter: (state) => {
			state.filter = {}
			state.queryFilter = {}
		},
		emptyInstances: (state) => {
			state.paginatedInstances.items = []
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchInstances.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(fetchInstances.fulfilled, (state, action) => {
				const paginatedInstances = action.payload

				state.paginatedInstances = paginatedInstances
				state.funcCurrentValuesMinMax = getFunctionalityCurrentValueMinMax(
					paginatedInstances.items
				)
				state.isLoading = false
			})
			.addCase(fetchInstances.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
			.addCase(fetchInstancesAll.pending, (state) => {
				state.allInstances.isLoading = true
				state.error = ''
			})
			.addCase(fetchInstancesAll.fulfilled, (state, action) => {
				state.allInstances.isLoading = false
				state.allInstances.items = action.payload
			})
			.addCase(fetchInstancesAll.rejected, (state, action) => {
				state.allInstances.isLoading = false
				state.allInstances.error = action.payload
			})
	}
})

export const { actions: instancesActions } = instancesSlice
export const { reducer: instancesReducer } = instancesSlice
